export interface GpsResult {
  lat: number;
  lng: number;
  accuracyM: number;
  detectionRadiusM: number;
  source: "device-geolocation";
}

export interface GpsErrorAccuracyTooLow {
  code: "ACCURACY_TOO_LOW";
  accuracyM: number;
}

export interface GpsErrorPermissionDenied {
  code: "PERMISSION_DENIED";
}

export interface GpsErrorPositionUnavailable {
  code: "POSITION_UNAVAILABLE";
}

export interface GpsErrorTimeout {
  code: "TIMEOUT";
}

export type GpsError =
  | GpsErrorAccuracyTooLow
  | GpsErrorPermissionDenied
  | GpsErrorPositionUnavailable
  | GpsErrorTimeout;

export function captureGps(maxAccuracyM = 100, detectionRadiusM = 150): Promise<GpsResult> {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const accuracyM = pos.coords.accuracy;
        if (accuracyM > maxAccuracyM) {
          reject({ code: "ACCURACY_TOO_LOW", accuracyM } satisfies GpsErrorAccuracyTooLow);
          return;
        }
        resolve({
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
          accuracyM,
          detectionRadiusM,
          source: "device-geolocation",
        });
      },
      (err) => {
        switch (err.code) {
          case GeolocationPositionError.PERMISSION_DENIED:
            reject({ code: "PERMISSION_DENIED" } satisfies GpsErrorPermissionDenied);
            break;
          case GeolocationPositionError.POSITION_UNAVAILABLE:
            reject({ code: "POSITION_UNAVAILABLE" } satisfies GpsErrorPositionUnavailable);
            break;
          case GeolocationPositionError.TIMEOUT:
            reject({ code: "TIMEOUT" } satisfies GpsErrorTimeout);
            break;
          default:
            reject({ code: "POSITION_UNAVAILABLE" } satisfies GpsErrorPositionUnavailable);
        }
      },
      { enableHighAccuracy: true, timeout: 15000 },
    );
  });
}
